import React from 'react'

export interface ITextProps {
  text: string
}

export const TextNavItem: React.FC<ITextProps> = (params) => (
  <span style={{ paddingRight: '5px' }}>{params.text}</span>
)
